import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowBoxLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-box-left, logout, leave, door"} maskId="square-filled-radius-0-stroke-1-IconArrowBoxLeft"><path fillRule="evenodd" clipRule="evenodd" d="M21.2071 12L16 17.2071L15.2929 16.5L19.2929 12.5L9 12.5V11.5L19.2929 11.5L15.2929 7.5L16 6.79289L21.2071 12Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M12 4L4 4L4 20H12V21H3L3 3L12 3V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowBoxLeft;
